import { useInfiniteRequest } from 'src/hook/useInfinityRequest'
import { GetWebinarsParams, LiveEndpoints, LiveService, WEBINAR_PAGE_SIZE } from 'src/services/live'

type useGetWebinarsQueryProps = {
  communityId: number
  params?: GetWebinarsParams
  enabled?: boolean
}

const useGetWebinarsQuery = ({ communityId, params, enabled = true }: useGetWebinarsQueryProps) =>
  useInfiniteRequest(
    [LiveEndpoints.getWebinars(communityId)],
    ({ signal }) => LiveService.getCommunityWebinars(communityId, params, signal),
    {
      enabled,
      getNextPageParam: (lastPage) => {
        const rows = params?.rows ?? WEBINAR_PAGE_SIZE

        if (lastPage?.page < Math.ceil(lastPage?.size / rows) - 1) {
          return lastPage?.page + 1
        }

        return undefined
      }
    }
  )

export default useGetWebinarsQuery
